import { motion } from "framer-motion";
import NavigationColored from './../components/NavigationColored';
import serviceImage from './../../assets/images/services/managed-office.jpg';
const pageVariants = {
    initial: { scale: 0.9, opacity: 0 },
    in: { scale: 1, opacity: 1 },
    out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
    type: "tween",
    ease: "easeInOut",
    duration: 0.5,
};

const ManagedOffice = () => {
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
        >
            <NavigationColored />
            <div style={{ marginTop: '4em' }}></div>
            <section className="service">
                <div className="container">
                    <div className="section-title" style={{  marginBottom: "50px" }}>
                                <h1>Managed Office</h1>
                                <p>“Move-In Ready Workspaces. Fully Serviced, Fully Flexible.”</p>
                            </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            
                            <p align="justify">Managed offices offer flexible, fully equipped workspaces with essential services for businesses and teams. These spaces come ready-to-use with high-speed internet, ergonomic furniture, meeting rooms, and professional reception services, allowing companies to focus on their core activities without the hassle of day-to-day office management. Ideal for startups, remote teams, and established enterprises alike, managed offices provide scalable solutions with short-term or long-term lease options. Whether you're looking for a private office, a collaborative area, or access to business amenities like printing, IT support, or mail handling, managed offices deliver convenience, cost-efficiency, and a professional image—all in one place.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 sub-services">
                            {/* <ul>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
                            </ul> */}
                            <img className="service-image" src={serviceImage} alt="service Image"/>
                        </div>
                    </div>
                </div>
            </section>
        </motion.div>
    );
};
export default ManagedOffice;